import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "main-content-view",
  class: "pt-4 container-fluid"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4 col-sm-3 col-xl-2" }
const _hoisted_4 = { class: "col-8 col-sm-9 col-xl-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SideMenu)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.fullPath
        }))
      ])
    ])
  ]))
}